import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import ContactForm from './contactform';
import { Link } from 'react-router-dom'; // Import Link from React Router


export const ContactPage = () => {
  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

        <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        <div className='backgroundImage-contact'>
          <img src={process.env.PUBLIC_URL + '/images/careerpage4.jpg'} alt="headImage" style={{ width: '100%', position:'relative', bottom:'0'}} />  
          <h1>CONNECT WITH US</h1>
        </div>


        <div className='contentForm'>
          <div className='contacts'>
            <ContactForm />
            <div className='contactinformation'>
                <h2>Contact Info</h2>
                <h3>Address</h3>
                <p>Lot 12, Lorong Pisang, <br/>Sedco Industrial Estate, <br/>Kolombong, <br/>88828 Kota Kinabalu, <br/>Sabah.</p>

                <h3>Phone</h3>
                <p>088-439350</p>

                <h3>Fax</h3>
                <p>088-439380</p>

                <h3>Email</h3>
                <p style={{ textDecoration:'underline', color:'red', textUnderlineOffset:'0.3rem'}}><a href="mailto:info@kombinasi-saudagar.com">info@kombinasi-saudagar.com</a></p>
            </div>
          </div>
          <div class="googlemap">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d992.023277973307!2d116.115603!3d5.981916!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x692b25418f8b5b0a!2sPembinaan%20Kekal%20Mewah%20Sdn.%20Bhd.!5e0!3m2!1sen!2smy!4v1663640490941!5m2!1sen!2smy" title='googlemap'></iframe>
          </div>
        </div>


        <div className='footer'>
          <FooterStyle />
        </div>

      </div>


    </div>
  );
}

export default ContactPage;
